import { takeLatest } from 'redux-saga/effects';
import {
  ANTRAGSNUMMER_EVENTS,
  GlobalActions,
  SOFORTSCHUTZ_AVAILABLE_REQUEST,
  VertragslaufzeitChanged,
  ZAEHLSTUECKEREQUEST,
} from '@ps20-frontend/shop-integration-redux';
import { addTaasLoadingActions } from './addTaasLoadingActions.util';
import { addTaasUpdateAppErrorHandling } from './addTaasUpdateAppErrorHandling';

export const updateAppActionsGenerator = ({ appId, angebotsId }: VertragslaufzeitChanged) => {
  return [
    new GlobalActions().antragsnummerRequested(appId, angebotsId),
    new GlobalActions().updateBeginnAblauf({ appId, angebotsId }),
    new GlobalActions().updateZaehlstuecke(),
    new GlobalActions().updateSofortschutzAvailable(),
  ];
};

export const updateAppSuccessActions = () => [
  GlobalActions.ANTRAGSNUMMER_GENERATED,
  GlobalActions.ZAEHLSTUECKE_RECEIVED,
  GlobalActions.SOFORTSCHUTZ_AVAILABLE,
];

export const updateAppFailActions = () => [
  SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_FAILED,
  ZAEHLSTUECKEREQUEST.ZAEHLSTUECKE_REQUEST_FAILED,
  ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
];

export const updateAppAndTarifiere = addTaasLoadingActions(
  addTaasUpdateAppErrorHandling(
    updateAppActionsGenerator,
    updateAppSuccessActions,
    updateAppFailActions,
  ),
);

export function* watchVertragslaufzeitChanged() {
  yield takeLatest(GlobalActions.VERTRAGSLAUFZEIT_CHANGED, updateAppAndTarifiere);
}
